import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-custom-layout',
  templateUrl: './custom-layout.component.html',
  styleUrls: ['./custom-layout.component.css']
})
export class CustomLayoutComponent implements OnInit {

  constructor(public translate: TranslateService, private dataService: DataService) { }

  private _name = '';

  receivedChildMessage: string;

  // @Input()
  // set pageTitle(name: string) {
  //   this._name = name;
  // }

  // get pageTitle(): string { return this._name; }



  title: string;
  ngOnInit() {

    //Make it dynamic to get from child
    // ashkan però hai fatto una bella jungla .\/.
    this.dataService.ComponentInput.subscribe((titleTranslateKey) => {
      if (titleTranslateKey) {
        this.translate.get([titleTranslateKey])
          .subscribe(values => {
            this.title = values[titleTranslateKey];
          })
      }

    });//this._name;

  }

}
